import { Routes } from '@angular/router';
import { redirectUnauthorizedToLogin } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  // '/calendar' is the Google Calendar OAuth redirect URI whitelisted server-side.
  // It receives ?code=... on return from Google and forwards to /reports/settings.
  {
    path: 'calendar',
    loadComponent: () =>
      import('./pages/calendar-callback/calendar-callback.page').then((m) => m.CalendarCallbackPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
